import { Injectable } from '@angular/core';
import {
  SlokaBackendModel,
  AddSlokaModel,
  UpdateSlokaModel,
} from '../interfaces/interfaces';
import { BACKEND_URL } from '../helpers/constants';
import { HttpClient } from '@angular/common/http';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  of,
} from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as S3 from 'aws-sdk/clients/s3';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SlokaDataService {
  private slokasListSubject = new BehaviorSubject<SlokaBackendModel[]>([]);

  private GET_SLOKAS_URL = `${BACKEND_URL}/sloka/getSlokas`;

  private DELETE_SLOKA_URL = `${BACKEND_URL}/sloka/deleteSloka`;

  private ADD_SLOKA_URL = `${BACKEND_URL}/sloka/addSloka`;

  private UPDATE_SLOKA_URL = `${BACKEND_URL}/sloka/updateSloka`;

  constructor(private http: HttpClient) {}

  getAllSlokasData(): Observable<SlokaBackendModel[]> {
    return this.http
      .post(this.GET_SLOKAS_URL, {})
      .pipe(map((r: any) => Object.values(r['result']) as SlokaBackendModel[]));
  }

  addSlokaData(addSloka: AddSlokaModel) {
    return this.http.post(this.ADD_SLOKA_URL, addSloka);
  }

  uploadAudioFileData(file: any, key: string): Observable<string> {
    let slokaAudioSubject = new AsyncSubject<string>();
    if (file != null) {
      const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-audio',
        Key: key,
        Body: file,
        ACL: 'public-read',
        ContentType: file.type,
      };

      bucket.upload(params, async (err: any, data: any) => {
        if (err == null) {
          slokaAudioSubject.next(data.Location);
        } else {
          slokaAudioSubject.next('error');
        }
        slokaAudioSubject.complete();
      });
      return slokaAudioSubject.asObservable();
    } else {
      slokaAudioSubject.next('');
      slokaAudioSubject.complete();
      return slokaAudioSubject.asObservable();
    }
  }

  uploadPdfFileData(file: any, key: string): Observable<string> {
    let slokaPdfSubject = new AsyncSubject<string>();
    if (file != null) {
      const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-pdf',
        Key: key,
        Body: file,
        ACL: 'public-read',
        ContentType: file.type,
      };

      bucket.upload(params, async (err: any, data: any) => {
        if (err == null) {
          slokaPdfSubject.next(data.Location);
        } else {
          slokaPdfSubject.next('error');
        }
        slokaPdfSubject.complete();
      });
      return slokaPdfSubject.asObservable();
    } else {
      slokaPdfSubject.next('');
      slokaPdfSubject.complete();
      return slokaPdfSubject.asObservable();
    }
  }

  deleteSlokaData(slokaId: string) {
    return this.http.post(this.DELETE_SLOKA_URL, { slokaId: slokaId });
  }

  updateSlokaData(updateSloka: UpdateSlokaModel) {
    return this.http.post(this.UPDATE_SLOKA_URL, updateSloka);
  }
}
